import React, { useState, useEffect } from "react";
import "./App.css";

import { DonutLarge, Chat, MoreVert, Search } from "@material-ui/icons";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import ChatList from "./components/Chat";
import ChatContent from "./components/Content";
import ChatWindow from "./components/Window";
import NewChat from "./components/NewChat";


import Login from "./pages/Login";
import ChatPage from "./pages/ChatPage";
import Register from './pages/Register';
import Profile from './pages/Profile';
import Home from "./pages/Home";
import Dropdown from "./pages/Dropdown";
import Translate from "./pages/Translate";
//import FormUser from "./pages/FormUser"; import UserProfile from "./pages/UserProfile";


const  App =() => {
  const [user, setUser] = useState({
    id: 1234,
    avatar:
      "https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60",
    name: "Pedro Moniz",
  });

  const [chatList, setChatList] = useState([
    {
      chatId: 1,
      title: "Pedro Moniz",
      image: "https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=60",
    },
  ]);

  const [activeChat, setActiveChat] = useState({});
  const [showNewChat, setShowNewChat] = useState(false);
  const [selected, setSelected] = useState ("Escolha um Usuario");

  return (

    <Router>
      <Routes>
        <Route path="/" exact element={<Login/>} />
        <Route path="/home" exact element={<Home/>} />
        <Route path="/chat" exact element={<ChatPage/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/translate" element={<Translate/>} />
        <Route path="/profile" element={<Profile/>} />

        <Route path="/type-user" element={<Dropdown selected={selected} setSelected={setSelected} />} />
        <Route path="*" element={<h1>Not found</h1>} />
      </Routes>
    </Router>

  );
  
};

export default App;